import { formatNumber, registerLocaleData } from '@angular/common';
import ru from '@angular/common/locales/ru';
import type { ISession, IStopPreviewResponse } from '../../models/sessions.models';
import { endOfParking } from './purchase-time';

registerLocaleData(ru);

/**
 * Сумма возврата для модалки Прерывания, ₸ в ru-формате («2 300», «81,66»): у платёжки нет LOCALE_ID,
 * и `number`-pipe форматировал в en-US («2,300»). null — сумму не показываем: предпросмотр не удался
 * или удержания ещё нет (сессия в START — предпросмотр её не видит и отдаёт нули, хотя вернётся всё).
 */
export function interruptRefund(
  preview: Pick<IStopPreviewResponse, 'total_paid' | 'refund_amount'> | null,
): string | null {
  if (!preview || !(preview.total_paid > 0)) {
    return null;
  }
  return formatNumber(preview.refund_amount / 100, 'ru', '1.0-2');
}

/** «стоянка до 16:00» в модалке Прерывания — окончание из предпросмотра по Алматы; нет — null. */
export function interruptUntil(
  preview: Pick<IStopPreviewResponse, 'stop_time'> | null,
): string | null {
  return preview?.stop_time ? endOfParking(preview.stop_time, 0).time : null;
}

export function stopSuccessMessage(
  preview: Pick<IStopPreviewResponse, 'total_paid' | 'refund_amount'> | null,
): { key: string; params?: { amount: string } } {
  const amount = preview && preview.refund_amount > 0 ? interruptRefund(preview) : null;
  return amount
    ? { key: 'SHARED_SESSION_STOPPED_REFUND', params: { amount } }
    : { key: 'SHARED_SESSION_STOPPED' };
}

export function canInterrupt(session: Pick<ISession, 'pay_type'>): boolean {
  return session.pay_type !== 'past';
}
